import { render, staticRenderFns } from "./DateForm.vue?vue&type=template&id=e0be87da"
import script from "./DateForm.vue?vue&type=script&lang=js"
export * from "./DateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports